import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  ColumnsModel,
  QueryBuilderComponent,
  QueryBuilderModule,
  RuleModel,
  TemplateColumn,
} from '@syncfusion/ej2-angular-querybuilder';
import {
  createElement,
  enableRipple,
  getComponent,
} from '@syncfusion/ej2-base';
import {
  DropDownList,
  DropDownListModule,
  MultiSelect,
  MultiSelectModule,
} from '@syncfusion/ej2-angular-dropdowns';
import {
  CheckBoxModule,
  RadioButtonModule,
} from '@syncfusion/ej2-angular-buttons';
import { Slider, SliderModule } from '@syncfusion/ej2-angular-inputs';
import {
  getNamedParameterSql,
  getParameterSql,
  updateRuleValue,
} from '../../utils/querybuilder';
import { AutomationmasterService } from '@fitness-force/api';
import { TranslateService } from '@ngx-translate/core';
import {
  AutomationField,
  AutomationMaster,
  DataBind,
  Operator,
} from '@fitness-force/models';
import { BehaviorSubject } from 'rxjs';
import { RouteStateService } from '../../router-guard/route-state-service.service';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'query-builder',
  templateUrl: './query-builder.component.html',
  styleUrls: ['./query-builder.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    SliderModule,
    QueryBuilderModule,
    MultiSelectModule,
    DropDownListModule,
    RadioButtonModule,
    CheckBoxModule,
    SkeletonModule,
  ]
})
export class AngularQueryBuilderComponent implements OnInit, OnChanges {
  @Input('tenantId') tenantId: number = 0;
  @Input('eventType') eventType: string;
  @Input('query') query: string = '';
  @Input('isDisabled') isDisabled: boolean = false;
  @Output('rule') rule: EventEmitter<{rule:string, sqlRule:string,jsonRule:string}> = new EventEmitter();
  @ViewChild('querybuilder') qryBldrObj: QueryBuilderComponent;

  automationMasters = new BehaviorSubject<AutomationMaster[]>([]);
  automationMaster = new BehaviorSubject<AutomationMaster>(
    {} as AutomationMaster
  );
  values: string[] = ['Mr.', 'Mrs.'];
  content: string;
  ruleValue: string[] = [];
  queryType: string = 'namedParemeter';
  importRules = new BehaviorSubject<RuleModel>({});
  columns = new BehaviorSubject<ColumnsModel[]>([]);
  separator: string = '.';
  showQueryBuilder = new BehaviorSubject<boolean>(false);
  items: { [key: string]: Object }[] = [];
  public inOperators: string[] = ['in', 'notin'];
  sqlRule: string ="";
  jsonRule: string ="";


  constructor(
    private automationService: AutomationmasterService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private stateService: RouteStateService
  ) {
    enableRipple(true);
  }

  ngOnInit(): void {
    //this.getAutomationMaster();
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle changes to the selectedOption input
    if (
      changes.eventType &&
      changes.eventType.currentValue != changes.eventType.previousValue
    ) {
      this.columns.next([]);
      this.importRules.next({});
      if (this.qryBldrObj) {
        this.qryBldrObj.reset();
        this.qryBldrObj.setRules({ condition: 'and', rules: [] });
        //this.updateContent();
      }
      this.cd.detectChanges();
      this.getAutomationMaster();
    }

    if (changes.query && changes.query.previousValue != undefined && changes.query.currentValue != changes.query.previousValue) {
      this.setQuery(changes.query.currentValue);
    }
  }

  getAutomationMaster() {
    if (
      this.stateService.getAutomationMasters().length > 0 &&
      this.stateService.getAutomationEventType() == this.eventType &&
      this.stateService.getAutomationTenantId() == this.tenantId
    ) {
      this.HandleResponse(this.stateService.getAutomationMasters());
    } else {
      this.automationService
        .GetAutomationMaster(this.tenantId, this.eventType.toString())
        .subscribe({
          next: (response: AutomationMaster[]) => {
            this.HandleResponse(response);
          },
          error: (error: any) => {},
        });
    }
  }

  HandleResponse(response: AutomationMaster[]) {
    this.automationMasters.next(response ? response : []);
    this.automationMaster.next(
      this.automationMasters.value.find(
        (o) => o.automation_type.toString() == this.eventType
      )!
    );
    this.stateService.setAutomationMasters(response);
    this.stateService.setAutomationEventType(this.eventType);
    this.stateService.setAutomationTenantId(this.tenantId);
    this.setColumns();
    this.setImportRules();
    this.showQueryBuilder.next(true);
    setTimeout(() => {
      // First reset the query builder
      this.qryBldrObj.reset();
      
      // Set the initial rules
      this.qryBldrObj.setRules(this.importRules.value);
      // If we have a query, try to set it
      this.setQuery(this.query);
      
      this.cd.detectChanges();
    }, 300);
  }

  setColumns() {
    let columns: ColumnsModel[] = [];
    let sortedFields = this.automationMaster.value.automation_fields.sort(
      (a, b) => (a.isdefault === b.isdefault ? 0 : a.isdefault ? -1 : 1)
    );
    sortedFields.forEach((o, index) => {
      let column: ColumnsModel = {} as ColumnsModel;
      let operators = this.getDistinctOperators(o.operators);
      if (o.data_bind && o.data_bind.length > 0)
        column.values = o.data_bind.map((o) => o.primaryName);
      if (operators && operators.length > 0) column.operators = operators;

      this.translateService
        .get('AUTOMATION.FIELDS.' + o.field_name)
        .subscribe((translation) => {
          (column.label = translation),
            (column.field = o.field_name),
            (column.type = o.column_type =='datepicker' ? 'date' : o.column_type),
            (column.template = this.setTemplate(o)),
            columns.push(column);
        });
    });
    this.columns.next(columns);
    this.cd.detectChanges();
  }

  setImportRules() {
    let rulesModels: RuleModel[] = [];
    let defaultRules = this.automationMaster.value.automation_fields.filter(
      (o) => o.isdefault || o.ismandatory
    );
    defaultRules.forEach((o, index) => {
      let rule: RuleModel = {} as RuleModel;
      let operators = this.getDistinctOperators(o.operators);
      this.translateService
        .get('AUTOMATION.FIELDS.' + o.field_name)
        .subscribe((translation) => {
          (rule.field = o.field_name),
            (rule.label = translation),
            (rule.type = o.column_type =='datepicker' ? 'date' : o.column_type),
            (rule.operator =
              operators.length > 0 ? (operators[0].value as string) : 'equal');
          rule.value = this.setDefaultValue(o);
        });
      rulesModels.push(rule);
    });
    let ruleModel: RuleModel = {} as RuleModel;
    ruleModel.condition = 'and';
    ruleModel.rules = rulesModels;
    this.importRules.next(ruleModel);
    this.cd.detectChanges();
  }

  setDefaultValue(field: AutomationField) {
    if (field.data_bind && field.data_bind.length > 0) {
      if (field.display_type == 'multiselect') {
        return [field.data_bind[0].id];
      } else {
        return field.data_bind[0].id;
      }
    } else {
      return field.column_type == 'number'
        ? '0'
        : field.column_type == 'string'
        ? ' '
        : undefined;
    }
  }

  change(args: any) {
    if (args.value === 'Inline') {
      this.queryType = 'inline';
    } else if (args.value === 'Parameterized') {
      this.queryType = 'parameterized';
    } else {
      this.queryType = 'namedParemeter';
    }
    this.updateContent();
  }

  updateContent(): void {
    let qbrule: RuleModel = this.qryBldrObj.getValidRules();
    switch (this.queryType) {
      case 'inline':
        this.sqlRule = this.qryBldrObj.getSqlFromRules(qbrule);
        break;
      case 'parameterized':
        this.convertParameterSql(qbrule);
        break;
      default:
        this.convertNamedParameterSql(qbrule);
        break;
    }
  }

  setTemplate(automationField: AutomationField): any {
    switch (automationField.display_type) {
      case 'dropdown':
        {
          if (
            automationField.data_bind &&
            automationField.data_bind.length > 0
          ) {
            return this.createDropdownTemplate(automationField.data_bind);
          } else {
            return undefined;
          }
        }
      case 'multiselect':
        {
          if (
            automationField.data_bind &&
            automationField.data_bind.length > 0
          ) {
            return this.createMultiselectTemplate(automationField.data_bind);
          } else {
            return undefined;
          }
        }
      default:
        return undefined;
    }
  }

  convertParameterSql(qbrule: RuleModel): void {
    this.ruleValue = updateRuleValue(qbrule, false);
    this.sqlRule = this.qryBldrObj.getSqlFromRules(qbrule);
    this.content = getParameterSql(this.content, this.ruleValue);
     this.sqlRule = this.generateSQLQuery(this.content)!;
    this.rule.emit({rule:this.content, sqlRule:this.sqlRule, jsonRule:this.jsonRule});
  }

  convertNamedParameterSql(qbrule: RuleModel): void {
    this.ruleValue = updateRuleValue(qbrule, true);
    this.content = this.qryBldrObj.getSqlFromRules(qbrule);
    this.sqlRule= this.qryBldrObj.getSqlFromRules(qbrule);
    this.content = getNamedParameterSql(this.content, this.ruleValue);
    this.sqlRule = this.generateSQLQuery(this.content)!;
    this.rule.emit({rule:this.content, sqlRule:this.sqlRule, jsonRule:this.jsonRule});
  }

  createDropdownTemplate(value: DataBind[]): TemplateColumn {
    let fieldData: { [key: string]: Object }[] = [];
    let fields: Object = { text: 'key', value: 'value' };
    value.forEach((o) => {
      const idValue = String(o.id);
      fieldData.push({ 
        key: o.primaryName || o.secondaryName, 
        value: idValue
      });
    });
    
    let templateColumn: TemplateColumn = {
      create: () => {
        return createElement('input', { attrs: { type: 'text' } });
      },
      destroy: (args: { elementId: string }) => {
        let dropdown: DropDownList = getComponent(
          document.getElementById(args.elementId)!,
          'dropdownlist'
        ) as DropDownList;
        if (dropdown) {
          dropdown.destroy();
        }
      },
      write: (args: {
        elements: Element;
        values: string[] | string;
        operator: string;
      }) => {
        const selectedValue = args.values ? String(args.values) : undefined;
        
        let dropDownObj: DropDownList = new DropDownList({
          dataSource: fieldData,
          fields: fields,
          value: selectedValue,
          change: (e: any) => {
            const newValue = e.itemData.value; 
            this.qryBldrObj.notifyChange(newValue, e.element);
          },
        });
        dropDownObj.appendTo('#' + args.elements.id);
      },
    };
    return templateColumn;
  }

  createMultiselectTemplate(value: DataBind[]) {
    let fieldData: { [key: string]: Object }[] = [];
    let fields: Object = { text: 'key', value: 'value' };
    value.forEach((o) => {
      fieldData.push({ key: o.primaryName || o.secondaryName, value: o.id });
    });
    let multiSelectTemplate = {
      create: () => {
        return createElement('input', { attrs: { type: 'text' } });
      },
      destroy: (args: { elementId: string }) => {
        let multiSelect: MultiSelect = getComponent(
          document.getElementById(args.elementId) as any,
          'multiselect'
        ) as MultiSelect;
        if (multiSelect) {
          multiSelect.destroy();
        }
        let dropdown: DropDownList = getComponent(
          document.getElementById(args.elementId) as any,
          'dropdownlist'
        ) as DropDownList;
        if (dropdown) {
          dropdown.destroy();
        }
      },
      write: (args: {
        elements: Element;
        values: string[] | string;
        operator: string;
      }) => {
        if (this.inOperators.indexOf(args.operator) > -1) {
          let multiSelectObj: MultiSelect = new MultiSelect({
            dataSource: fieldData,
            value: args.values as string[],
            mode: 'CheckBox',
            placeholder: 'Select',
            fields: fields,
            change: (e: any) => {
              this.qryBldrObj!.notifyChange(e.value, e.element);
            },
          });
          multiSelectObj.appendTo('#' + args.elements.id);
        } else {
          let dropDownObj: DropDownList = new DropDownList({
            dataSource: fieldData,
            value: args.values as string,
            fields: fields,
            change: (e: any) => {
              this.qryBldrObj!.notifyChange(e.itemData.value, e.element);
            },
          });
          dropDownObj.appendTo('#' + args.elements.id);
        }
      },
    };
    return multiSelectTemplate;
  }

  createAmountTemaplte() {
    let amountTemplate: TemplateColumn = {
      create: () => {
        return createElement('div', { className: 'ticks_slider' });
      },
      destroy: (args: { elementId: string }) => {
        (
          getComponent(
            document.getElementById(args.elementId)!,
            'slider'
          ) as Slider
        ).destroy();
      },
      write: (args: { elements: Element; values: number }) => {
        const ticksSlider: Slider = new Slider({
          value: args.values,
          min: 0,
          max: 100,
          type: 'MinRange',
          // Initialize tooltip with placement and showOn
          tooltip: { isVisible: true, placement: 'Before', showOn: 'Hover' },
          change: (e: any) => {
            if (e.isInteracted) {
              this.qryBldrObj.notifyChange(e.value, args.elements);
            }
          },
        });
        ticksSlider.appendTo('#' + args.elements.id);
      },
    };
  }

  getDistinctOperators(operators: Operator[]) {
    const uniqueOperators = new Set();
    // Filter the array to get distinct records based on both value and key
    const distinctOperators = operators.filter((item) => {
      const key = JSON.stringify(item);
      if (!uniqueOperators.has(key)) {
        uniqueOperators.add(key);
        return true;
      }
      return false;
    });
    let fieldData: { [key: string]: Object }[] = [];
    distinctOperators.forEach((o) => {
      fieldData.push({ key: o.key, value: o.value });
    });
    return fieldData;
  }

  getfieldValues(values: DataBind[]) {
    return values.map((o) => o.id);
  }

  generateSQLQuery(rule: string): string {
    try {
      const ruleJson = JSON.parse(rule);
      const sqlRule = ruleJson.sql;
      const params = ruleJson.params || {};
      const dynamicSqlRule = sqlRule.replace(/:\w+/g, (placeholderKey: string) => {
          const key = placeholderKey.substring(1); // Remove ":" from the key
          return params[key]; // Replace placeholder with corresponding value
      });
      return dynamicSqlRule;
    } catch (error) {
        console.error("Error:", error);
        return "";
    }
}

setQuery(query: string) {
  if (this.query && this.query.trim() !== '') {
    try {
      // Clean up the query if needed
      const cleanQuery = this.query.replace(/\s+/g, ' ').trim();
      
      // Reset before setting new rules
      this.qryBldrObj.reset();
      
      // Set rules from SQL
      this.qryBldrObj.setRulesFromSql(cleanQuery);
      
      // Get the current rules and ensure values are strings
      const currentRules = this.qryBldrObj.getValidRules();
      
      if (currentRules && currentRules.rules) {
        // Convert any numeric values to strings for consistent handling
        currentRules.rules = currentRules.rules.map(rule => {
          if (rule.value !== undefined && rule.value !== null) {
            rule.value = String(rule.value);
          }
          return rule;
        });
        // Set the updated rules
        this.qryBldrObj.setRules(currentRules);
      }
      
      // Force update the content
      this.updateContent();
    } catch (error) {
      console.error('Error setting rules from SQL:', error);
    }
  }
}

}
